const popupContent = {
    textAlign: "center",
    height: "350px",
    marginTop: "30px"
};
const popupHead = {
    fontWeight: "bold",
    fontSize: "22px"
};

const popupText = {
    fontSize: "15px",
    marginBottom: "20px"
};

const okText = {
    fontSize: "15px"
};

export { popupContent, popupHead, popupText, okText };